export default {
  Sources: {
    HEADING: 'Sources',
    NO_SYNC: "Not sync'd yet",
    IN_PROGRESS: 'Sync in progress',
    COMPLETED: 'Last sync: {{date}}',
    PARTIAL: "Partially sync'd on: {{date}}",
    DISCONNECTED: 'Disconnected',
    ERROR: 'Sync failed',
    SYNC_IN_PROGRESS:
      'We are currently synchronising transactions with Xero, so data may not be up to date just yet.',
    Table: {
      Headers: {
        NAME: 'Name',
        TYPE: 'Source',
        DATA_TYPES: 'Data Types',
        STATUS: 'Connection Status',
      },
    },
    Types: {
      mayday: 'Mayday',
      xero: 'Xero',
      googleSheets: 'Google Sheets',
    },
    DataTypes: {
      nominalCodes: 'Account Codes',
      contacts: 'Contacts',
      trackingCategories: 'Tracking Categories',
      transactions: 'Transactions',
    },
    Create: {
      Xero: {
        DESCRIPTION:
          'The Xero source collects Account Codes, Contacts, Tracking Categories, and Transactions.',
      },
      GoogleSheets: {
        DESCRIPTION:
          "The Google Sheets source collects transactions. It's useful for things which won't appear in Xero, such as individual's salary lines which need to be recharged.",
      },
    },
  },
};
